import React from "react";
import arrow from "../assets/arrow.svg";

export default function Pagination(props) {
  const { data, onPageClick } = props;

  /*Render pagination*/
  function pagination() {
    if (data.length === 0) {
      return;
    }

    const pages = parseInt(data.maxnumpages);
    const currentPage = parseInt(data.paged);

    //No pages return
    if (pages === 1) {
      return;
    }

    let pagesArr = Array.from({ length: pages }, (_, i) => i + 1);

    //Next button
    if (pagesArr.length !== currentPage) {
      pagesArr.push("next");
    }

    //Prev button
    if (currentPage !== 1) {
      pagesArr.unshift("prev");
    }

    //Add ... if more than 10 pages
    if (pages > 10) {
      let leftPagesArr = [];
      let rightPagesArr = [];
      if (currentPage > 5) {
        leftPagesArr = pagesArr.slice(0, 3);
        leftPagesArr.push("...", currentPage - 1);
      } else {
        if (currentPage !== 1) {
          leftPagesArr = pagesArr.slice(0, currentPage);
        }
      }

      if (pagesArr.length - 5 > currentPage) {
        rightPagesArr = pagesArr.slice(-3);
        rightPagesArr.unshift(currentPage, currentPage + 1, "...");
      } else {
        rightPagesArr = pagesArr.slice(-(pagesArr.length - currentPage));
      }

      pagesArr = [...leftPagesArr, ...rightPagesArr];
    }

    //Create pagination for rendering
    const pagination_arr = pagesArr.map((page, index) => {
      let pageLabel = page;

      if (page === "prev") {
        pageLabel = (
          <img
            className="prev-arrow pagination-arrow"
            src={arrow}
            alt="arrow"
          />
        );
        page = currentPage - 1;
      }

      if (page === "next") {
        pageLabel = (
          <img
            className="next-arrow pagination-arrow"
            src={arrow}
            alt="arrow"
          />
        );
        page = currentPage + 1;
      }

      return (
        <li
          className={`pag-page ${currentPage === page ? "active" : ""} ${
            page === "..." ? "pag-dot" : ""
          }`}
          onClick={onPageClick}
          key={index}
          data-page={page}
        >
          {pageLabel}
        </li>
      );
    });

    return pagination_arr;
  }

  return (
    <>
      <ul className="pagination">{pagination()}</ul>
    </>
  );
}
